import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import Authenticated from 'Components/Layouts/Authenticated';
import { asset } from "Services/BaseHelpers";
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";
import RegisterButton from "Components/Button/RegisterButton";
import { Loading } from "Components/Partials";
import { RenderWYSIWYG } from "Components/Form";
import CmsElement from "Components/Utilities/CmsElement";

import { User } from "Services";
import { getRecordValue } from "Services/CmsHelpers";

export default class Tokyo extends CmsElement {
    cmsElementIdentifier = 'tokyo';

    /**
     * @var state
     */
    state = {
        working: true
    };

    gallery = [
        {
            url: 'waves.jpg',
            text: 'Tokyo was originally knows as \'Edo\' until it was renamed in 1868',
        },
        {
            url: 'crowd.jpg',
            text: 'Tokyo is the most populous city in the world, with a population of over ' +
                '37 million people in its greater metropolitan area.',
        },
        {
            url: 'train.jpg',
            text: 'Tokyo’s subway is known for being highly efficient and punctual to ' +
                'the second, with an average delay of only 18 seconds.',
        },
        {
            url: 'bowing.jpg',
            text: 'If someone bows to you, it is polite to return the bow. Another strictly ' +
                'observed tradition is to take off your shoes when entering any temple or home.',
        },
        {
            url: 'sunset_house.jpg',
            text: 'There are a whopping 1,450 shrines located across Tokyo.',
        },
        {
            url: 'night_signs.jpg',
            text: 'If you count all the neon signs in the city, it beats Piccadilly Circus, Times Square, and even Las Vegas!',
        },
        {
            url: 'kitkat.jpg',
            text: 'Tokyo’s KitKat Chocolatory offers an extraordinary variety of KitKat flavours exclusive to Japan. ' +
                'Some of the most out-there include wasabi, sake, matcha green tea, purple sweet potato, ' +
                'and even soy sauce flavoured KitKats (we hope you enjoyed the flavour that dropped onto your desk!)',
        },
        {
            url: 'drinks.jpg',
            text: 'Across Japan there are over 5 million vending machines, ' +
                'with a population of 125 million that equals almost one vending machine for every 25 people.' +
                ' From hamburgers to umbrellas to bananas and anything in between, you will find a vending machine ' +
                'at least every 12 meters. There is also a “mystery vending machine” that dispenses a random item ' +
                'wrapped in white paper.',
        },
     ]
    render () {
        const { working, records } = this.state;
        const content = {};
        let ctas = [];
        let carousel = [];

        if (records) {
             records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'content')
                .forEach(item => {
                    content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
                });

            ctas = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'cta')
                .map(item => ({
                    title: getRecordValue(item, 'title'),
                    content: getRecordValue(item, 'content'),
                    image: getRecordValue(item, 'image', 'file'),
                }));

            carousel = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'carousel')
                .map(item => getRecordValue(item, 'image', 'file'));
        }


        return (
            <Authenticated title="Dashboard">
                <PageHeader
                    imgSrc="headers/tokyo.png"
                />

                {working && (<Loading />)}

                {!working && content && (
                    <>
                        <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                            <div className="flex justify-center pb-4">
                                <img
                                    src={asset('images/mini-logo.png')}
                                    alt="Logo"
                                    className="block w-20 align-self-center"
                                />
                            </div>

                            <div className="text-center">
                                <RenderWYSIWYG
                                    className="text-black"
                                    content={content['Welcome Text'] ?? ''}
                                />
                            </div>
                        </div>

                        <div className="max-w-screen mx-auto py-10 px-5 md:px-10 flex items-center justify-center">
                            <div className="justify-center grid grid-cols-[repeat(1,minmax(100px,500px))] md:grid-cols-[repeat(2,minmax(100px,500px))] xl:grid-cols-[repeat(3,minmax(100px,500px))] gap-6 w-full">
                                  <div className=" relative cursor-pointer h-full w-full">
                                      <img
                                          className="w-full"
                                          src={asset('images/tokyo/start.png' )}
                                      />
                                  </div>

                                  { this.gallery.map(item =>
                                      <div className="group  w-full">
                                          <figure className=" relative cursor-pointer ">
                                              { item.url && (
                                                  <img
                                                    className="w-full"
                                                    src={asset('images/tokyo/' + item.url)}
                                                  />
                                              )}

                                              { item.text && (
                                                  <figcaption className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-sm md:text-lg text-white w-3/4">
                                                      <div className={"flex items-center justify-center"}>
                                                          <p className="opacity-0 group-hover:opacity-100 duration-300 w-full text-center">
                                                              {item.text}
                                                          </p>
                                                      </div>
                                                  </figcaption>
                                              )}
                                          </figure>
                                      </div>
                                  )}
                            </div>

                        </div>
                        <div className="bg-app-yellow">
                            <div className="max-w-4xl mx-auto p-10">
                                <div className="grid grid-cols-2 lg:grid-cols-3 gap-10">
                                    {ctas?.map((cta, key) => (
                                        <div key={`cta-${key}`} className="text-center text-black">
                                            <img src={cta.image} className="object-contain w-20 h-20 mx-auto" />
                                            <p className="font-bold mt-4">{cta.title}</p>
                                            <RenderWYSIWYG
                                                className="text-black text-center"
                                                content={cta.content ?? ''}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <Carousel
                            showIndicators={false}
                            showThumbs={false}
                            showStatus={false}
                            renderArrowPrev={(clickHandler) => (
                                <div className="left-10 absolute inset-y-0 flex items-center z-10">
                                    <FontAwesomeIcon
                                        onClick={clickHandler}
                                        className="text-white transition duration-200 hover:scale-110 cursor-pointer"
                                        icon={faChevronLeft}
                                        size="2x"
                                    />
                                </div>
                            )}
                            renderArrowNext={(clickHandler) => (
                                <div className="right-10 absolute inset-y-0 flex items-center z-10">
                                    <FontAwesomeIcon
                                        onClick={clickHandler}
                                        className="text-white transition duration-200 hover:scale-110 cursor-pointer"
                                        icon={faChevronRight}
                                        size="2x"
                                    />
                                </div>
                            )}
                        >
                            {carousel?.map((carousel, key) => (
                                <div key={`carousel-${key}`}>
                                    <img src={carousel} />
                                </div>
                            ))}
                        </Carousel>

                        {/*<div className="bg-black p-4 md:p-8 border-t-12 border-app-yellow">*/}
                        {/*    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">*/}
                        {/*        <div className="flex items-center justify-center font-bold px-2 md:px-6 lg:px-12">*/}
                        {/*            <RenderWYSIWYG*/}
                        {/*                className="text-white"*/}
                        {/*                content={content['CTA Left'] ?? ''}*/}
                        {/*            />*/}
                        {/*        </div>*/}

                        {/*        <img src={asset('images/cta-right.png')} />*/}
                        {/*        <img src={asset('images/cta-left.png')} />*/}

                        {/*        <div className="flex items-center justify-center px-2 md:px-6 lg:px-12">*/}
                        {/*            <RenderWYSIWYG*/}
                        {/*                className="text-white"*/}
                        {/*                content={content['CTA Right'] ?? ''}*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<div className="bg-app-yellow text-center py-6">*/}
                        {/*    <RenderWYSIWYG*/}
                        {/*        className="text-black font-bold"*/}
                        {/*        content={content['Video CTA'] ?? ''}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {/*<img src={asset('images/video-cta.jpg')} />*/}
                    </>
                )}

                {/*{this.renderOpeningTextSection()}*/}
                {/*{this.renderOpeningEventSection()}*/}
                {/*{this.renderOpeningVideoSection()}*/}
                {/*{this.renderOpeningDeadlineSection()}*/}
                {/*{this.renderOpeningPicturesSection()}*/}
            </Authenticated>
        );
    }

    renderOpeningTextSection () {
        let eventLink;

        switch( User.data?.groups[0]?.name ) {
            case 'HOB':
                eventLink = 'https://cvent.me/dXwmdP';
                break;
            case 'ICO':
            default:
                eventLink = 'https://cvent.me/QDl0RZ';
        }

        return (
            <Section>
                <div className="flex justify-center">
                    <img
                        src={asset('images/mini-logo.png')}
                        alt="Logo"
                        className="block w-20 align-self-center"
                    />
                </div>

                <p className="bmw-bold text-2xl bmw-condenced-bold">
                    INVESTOR, OWNER AND FRANCHISE DIRECTORS: 25 APRIL TO 1 MAY
                    <br />
                    HEADS OF BUSINESS: 26 APRIL TO 2 MAY
                    <br/>
                    <span className={"bmw-light"}>
                        (All dates include travel)
                    </span>
                </p>

                <p className={"bmw-light"}>
                    Chris Brownridge and the Management Committee are very much looking forward to welcoming you to Cape Town for the BMW Group UK Retailer Convention this coming April.
                </p>
                <p className={"bmw-light"}>
                    This Convention will set out the future ahead, the strategic outlook and direction for all of our businesses.
                </p>
                <p className={"bmw-light"}>
                    Please take a moment to watch the teaser film and then read some of the highlights to what is set to be an exceptional trip and a key milestone for our future.
                </p>
                <p className={"bmw-bold"}>
                    You are required to formally register your attendance, for both you and your guest, before 17:00 Friday 24 February.
                </p>
                <div className={"pt-3"}>
                    <a href={eventLink} target={"_blank"} className={"pt-4"}>
                        <RegisterButton text="Register Now" />
                    </a>
                </div>
            </Section>
        )
    }
    renderOpeningEventSection () {
        return (
            <div className="bg-event">
                <Section>
                    <div className={"flex flex-row text-white text-left"}>
                        <div className={"my-auto mx-auto w-2/3 bmw-condenced-regular"}>
                            <p className={"text-lg"}>
                                The Event
                            </p>
                            <p className={"text-sm pb-4"}>
                                The BMW Group UK Convention will set out the strategic vision for our businesses.
                            </p>
                            <p className={"text-lg"}>
                                The Location
                            </p>
                            <p className={"text-sm"}>
                                We have chosen South Africa to host this event as they have already gone through the Future Sales Model changes.
                                With experts on hand, it’ll offer a unique insight into how their business has changed and the adaptions that
                                have been made.
                                Whether you’re a first time visitor to Cape Town or well-acquainted with this multifaceted city,
                                we have a schedule filled with exclusive experiences to showcase everything this incredible destination has to offer!

                            </p>
                        </div>
                        <div className={"my-auto mx-auto w-1/3"}>
                            <img className={"my-auto mx-auto "} src={ asset ( 'images/event_logo.png' ) } />
                        </div>
                    </div>
                </Section>
            </div>
        )
    }
    renderOpeningVideoSection () {
        return (
            <Section>
                <p className={"text-2xl bmw-condenced-bold"}>
                    INTERESTED?
                </p>
                <p className={"bmw-condenced-bold"}>
                    Here’s a sneak peek of what’s in store…
                </p>
                <iframe
                    src={"https://player.vimeo.com/video/794162518?h=1f5a6d289d"}
                    className="my-4 md:my-12 h-full w-full mx-auto px-2 md:px-6 rounded-lg h-96"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
                <p className={"bmw-condenced-bold text-2xl pt-6"}>
                    SECURE YOUR PLACE
                </p>
                <p className={"bmw-condenced-bold"}>
                    Want to be at the BMW Group UK Retailer Convention 2023 in Cape Town, South Africa?
                    Here’s what you need to do:
                </p>
                <div className={"grid grid-cols-1 lg:grid-cols-4 gap-5 bmw-light text-sm"}>
                    <div>
                        <p className={"text-center text-xl"}>1.</p>
                        Please formally register your attendance, for both you and your guest, before Friday 24 February.
                    </div>
                    <div>
                        <p className={"text-center text-xl"}>2.</p>
                        Look out for further information and updates regarding hotels and flights. You’ll have a
                        dedicated BMW UK Events Team on hand to help with confirming your arrangements.
                    </div>
                    <div>
                        <p className={"text-center text-xl"}>3.</p>
                        You’ll receive a personalised travel agenda and access to the ‘Retailer Convention app’
                        before travel to ensure you have all the information you need before departure.
                    </div>
                    <div>
                        <p className={"text-center text-xl"}>4.</p>
                        Pack your bags and grab your passports. We look forward to seeing you in Cape Town in April!
                    </div>
                </div>
            </Section>
        )
    }
    renderOpeningDeadlineSection () {
        return (
            <div className="bg-deadline">
                <Section>
                    <img className={"mx-auto my-auto"} src={ asset ( 'images/clock.png' ) } />
                    <p className={"bmw-condenced-bold text-2xl text-white uppercase"}>
                        Deadline
                    </p>
                    <p className={"bmw-condenced-bold text-white text-sm"}>
                        Remember to register by Friday 24 February 2023 to secure your place!
                    </p>
                </Section>
            </div>
        )
    }
    renderOpeningPicturesSection () {
        return (
            <Section>
                <div className={"grid grid-cols-1 lg:grid-cols-3 gap-4"}>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/cable_car.png' ) } />
                    </div>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/waterfront_convention.png' ) } />
                    </div>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/hout_bay.png' ) } />
                    </div>
                </div>
                <QuestionSection />
            </Section>
        )
    }
}
